import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PortalLayoutsRoutingModule } from './portal-layouts-routing.module';
import { PortalLayoutsComponent } from './portal-layouts.component';
import { PortalHeaderComponent } from './portal-header/portal-header.component';
import { PortalFooterComponent } from './portal-footer/portal-footer.component';
import { PortalSidebarComponent } from './portal-sidebar/portal-sidebar.component';
import { PortalDashComponent } from '../portal-dash/portal-dash.component';
import { PortalProductsComponent } from '../portal-products/portal-products.component';
import { TaskComponent } from '../task/task.component';
import { AccountProfileComponent } from '../account-profile/account-profile.component';
import { PortalUserProfileComponent } from '../portal-user-profile/portal-user-profile.component';
import { ApprovalComponent } from '../approval/approval.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FileUploadModule } from 'ng2-file-upload';
import { NgChartsModule } from 'ng2-charts';
import { SharedModule } from '../../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  declarations: [
    PortalLayoutsComponent,
    PortalHeaderComponent,
    PortalFooterComponent,
    PortalSidebarComponent,
    PortalDashComponent,
    PortalProductsComponent,
    TaskComponent,
    AccountProfileComponent,
    PortalUserProfileComponent,
    ApprovalComponent,
  ],
  exports: [
    PortalHeaderComponent,
    PortalFooterComponent,
    PortalSidebarComponent,
  ],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    PortalLayoutsRoutingModule,
    NgSelectModule,
    NgChartsModule,
    FileUploadModule,
    MatInputModule,
    MatSlideToggleModule,
    MatStepperModule,
    MatCheckboxModule,
    MatExpansionModule,
    NgxSpinnerModule,
    HttpClientModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    ToastrModule.forRoot(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PortalLayoutsModule { }
